import React from "react";
import Layout from "@/components/Layout";
import HomeSearchOverlay from "@/components/Pages/Home/HomeSearchOverlay";
import SearchPcView from "@/components/Pages/Search/SearchPcView";
import useIsDesktop from "@/hooks/useIsDesktop";
import { getCommonStaticProps } from '@/utils/method'

function SearchPageContent() {
  const { isDesktop, isReady } = useIsDesktop();

  const handleClose = () => {
    if (typeof window !== 'undefined') {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    }
  };

  if (!isReady) {
    return null;
  }

  if (isDesktop) {
    return <SearchPcView />;
  }

  return <HomeSearchOverlay visible={true} onClose={handleClose} />;
}

const SearchPage = () => {
  return (
    <Layout isShowNav={true} isShowFoot={false} useBottomBar={false}>
      <SearchPageContent />
    </Layout>
  );
};

export default SearchPage;

export async function getStaticProps(context) {
  return getCommonStaticProps(context);
}
